import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MessageIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_284_528)">
        <path
          d="M6.23809 30C7.82541 30 11.7804 28.2407 14.0291 26.6024C14.254 26.4412 14.4391 26.3741 14.6243 26.3741C14.7964 26.3875 14.9683 26.401 15.1402 26.401C24.6773 26.401 31 20.895 31 14.2071C31 7.45227 24.3334 2 16.0001 2C7.66667 2 1 7.45227 1 14.2071C1 18.5045 3.60582 22.2782 7.85186 24.588C8.05027 24.6955 8.11641 24.8969 8.01059 25.0983C7.26985 26.3338 5.94709 27.811 5.44445 28.4825C4.92858 29.1539 5.21958 30 6.23809 30Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_284_528">
          <rect width="30" height="28" fill="currentColor" transform="translate(1 2)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
